import React, {useContext} from 'react';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import './UyoImageRotate.sass';
import {charcoal, pebble} from '~libSass/base/_exports.sass';
import {Typography} from '~library/atoms/Typography';
import {RotationIcon} from '~library/svg/RotationIcon';

export const UyoImageRotate = ({btnText = '', disabled}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);

  const rotate = () => {
    const target = activeObjects?.[0];
    target.rotate(target.angle - 30);
    canvas.renderAll();
    canvas.fire('object:modified');
  };

  return (
    <div className="uyo_control__rotate_button" onClick={rotate}>
      <RotationIcon color={disabled ? pebble : charcoal} />
      {btnText && (
        <Typography
          as="p"
          variant="paragraph3"
          size="medium"
          color={disabled ? 'pebble' : 'charcoal'}
        >
          {btnText}
        </Typography>
      )}
    </div>
  );
};
